/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddFeaturedTagRequest,
    EditFeaturedTagRequest,
    IdResponse,
    ReorderFeaturedTagsRequest,
} from '../models';

export interface FeaturedTagsApiControllerAddFeaturedTagRequest {
    addFeaturedTagRequest: AddFeaturedTagRequest;
}

export interface FeaturedTagsApiControllerDeleteFeaturedTagRequest {
    id: string;
}

export interface FeaturedTagsApiControllerEditRequest {
    id: string;
    editFeaturedTagRequest: EditFeaturedTagRequest;
}

export interface FeaturedTagsApiControllerReorderFeaturedTagRequest {
    reorderFeaturedTagsRequest: ReorderFeaturedTagsRequest;
}

/**
 * 
 */
export class FeaturedTagApi extends runtime.BaseAPI {

    /**
     * Create a new featured tag
     */
    async featuredTagsApiControllerAddFeaturedTagRaw(requestParameters: FeaturedTagsApiControllerAddFeaturedTagRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.addFeaturedTagRequest === null || requestParameters.addFeaturedTagRequest === undefined) {
            throw new runtime.RequiredError('addFeaturedTagRequest','Required parameter requestParameters.addFeaturedTagRequest was null or undefined when calling featuredTagsApiControllerAddFeaturedTag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-tags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addFeaturedTagRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a new featured tag
     */
    async featuredTagsApiControllerAddFeaturedTag(requestParameters: FeaturedTagsApiControllerAddFeaturedTagRequest): Promise<IdResponse> {
        const response = await this.featuredTagsApiControllerAddFeaturedTagRaw(requestParameters);
        return await response.value();
    }

    /**
     * Delete the given featured tag
     */
    async featuredTagsApiControllerDeleteFeaturedTagRaw(requestParameters: FeaturedTagsApiControllerDeleteFeaturedTagRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling featuredTagsApiControllerDeleteFeaturedTag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-tags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the given featured tag
     */
    async featuredTagsApiControllerDeleteFeaturedTag(requestParameters: FeaturedTagsApiControllerDeleteFeaturedTagRequest): Promise<void> {
        await this.featuredTagsApiControllerDeleteFeaturedTagRaw(requestParameters);
    }

    /**
     * Edit an existing featured tag. Currently can only edit sellerTags
     */
    async featuredTagsApiControllerEditRaw(requestParameters: FeaturedTagsApiControllerEditRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling featuredTagsApiControllerEdit.');
        }

        if (requestParameters.editFeaturedTagRequest === null || requestParameters.editFeaturedTagRequest === undefined) {
            throw new runtime.RequiredError('editFeaturedTagRequest','Required parameter requestParameters.editFeaturedTagRequest was null or undefined when calling featuredTagsApiControllerEdit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-tags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editFeaturedTagRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Edit an existing featured tag. Currently can only edit sellerTags
     */
    async featuredTagsApiControllerEdit(requestParameters: FeaturedTagsApiControllerEditRequest): Promise<IdResponse> {
        const response = await this.featuredTagsApiControllerEditRaw(requestParameters);
        return await response.value();
    }

    /**
     * Reorder tags in bulk
     */
    async featuredTagsApiControllerReorderFeaturedTagRaw(requestParameters: FeaturedTagsApiControllerReorderFeaturedTagRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.reorderFeaturedTagsRequest === null || requestParameters.reorderFeaturedTagsRequest === undefined) {
            throw new runtime.RequiredError('reorderFeaturedTagsRequest','Required parameter requestParameters.reorderFeaturedTagsRequest was null or undefined when calling featuredTagsApiControllerReorderFeaturedTag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-tags:reorder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.reorderFeaturedTagsRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reorder tags in bulk
     */
    async featuredTagsApiControllerReorderFeaturedTag(requestParameters: FeaturedTagsApiControllerReorderFeaturedTagRequest): Promise<void> {
        await this.featuredTagsApiControllerReorderFeaturedTagRaw(requestParameters);
    }

}
